import { CheckCircleOutline } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from 'stores/storeInitializer';
import CompanyCard from '../CompanyCard';
import { CompanyCardData } from '../CompanyCard/companyCardData';

interface SubmittedSuccessProps {
    company?: CompanyCardData;
}

/**
 * The end state after a submission was accepted. It is a success, not an error and not a disabled form: there is
 * nothing left to edit or retry, so it offers no controls. The company (Company journey only) is shown read-only.
 */
export const SubmittedSuccess: React.FC<SubmittedSuccessProps> = observer(({ company }) => {
    const { store } = useStores();

    return (
        <Box role="status" display="flex" flexDirection="column" alignItems="center" gap={2} textAlign="center">
            <CheckCircleOutline color="success" sx={{ fontSize: 64 }} aria-hidden />
            <Typography variant="h5" component="h1">
                {store.L(LocalizationKeys.BillingDetailsSubmitted)}
            </Typography>
            <Typography color="text.secondary">
                {store.L(LocalizationKeys.BillingDetailsSubmittedNote)}
            </Typography>
            {company ? (
                <Box width="100%" textAlign="left">
                    <CompanyCard data={company} />
                </Box>
            ) : null}
        </Box>
    );
});

export default SubmittedSuccess;
